import React from 'react'
import injectStyles from 'react-jss'

import { Col } from 'react-bootstrap'
import { LayoutAuth } from 'Components/Layout/Auth'
import { BackgroundLogo } from 'Components/Sidebar/BackgroundLogo'

import styles from './styles'

const PublicInformationView = props => {
  const { classes, title, description, children } = props

  return (
    <LayoutAuth>
      <Col xs={12} md={6} className={classes.logo}>
        <BackgroundLogo />
      </Col>
      <Col xs={12} md={6}>
        <div className={classes.container}>
          <div className={classes.inner}>
            <h1>{title}</h1>
            <br />
            <p>{description}</p>
            <br />
            {children}
          </div>
        </div>
      </Col>
    </LayoutAuth>
  )
}

export default injectStyles(styles)(PublicInformationView)



// WEBPACK FOOTER //
// ./src/Components/Auth/PublicInformationView/index.js